// Occupational Health and Safety page Indonesian translations

export default {
  pageTitle: "Keberlanjutan",
  breadcrumbHome: "Beranda",
  breadcrumbSustainability: "Keberlanjutan",
  breadcrumbCurrent: "Inisiatif Kesehatan dan Keselamatan Kerja",
  
  // Page Header
  title: "Inisiatif Kesehatan dan Keselamatan Kerja",
  
  // Navigation
  navSustainability: "Keberlanjutan",
  navConceptOfSustainability: "Konsep Keberlanjutan",
  navEnvironmentalInitiatives: "Inisiatif Lingkungan",
  navSocialContributionInitiatives: "Inisiatif Kontribusi Sosial",
  
  // Main Content
  mainTitle: "Kesehatan dan Keselamatan Kerja di Eagle Industry Indonesia",
  mainDescription: "Grup EKK selalu berusaha untuk membangun lingkungan kerja yang mendukung kesejahteraan fisik dan mental karyawan. Prinsip Keselamatan menjadi landasan bahwa keselamatan tidak hanya menjadi pilar perusahaan, tetapi juga individu dalam Grup.",
  
  // Health and Safety Management
  healthSafetyManagementTitle: "Manajemen Kesehatan dan Keselamatan Kami",
  healthSafetyManagementDesc: "Keselamatan kerja adalah prioritas utama kami. Grup EKK mengelola K3 melalui organisasi yang terstruktur yang dipimpin langsung oleh manajemen puncak. Dengan menerapkan standar internasional ISO 45001:2018 (Kesehatan dan Keselamatan Kerja), kami memastikan semua kegiatan operasional berjalan dengan aman, sehat, dan berkelanjutan.",
  
  // OHS Policies
  ohsPoliciesTitle: "Kebijakan Kesehatan dan Keselamatan Kerja EKK",
  
  // Basic Group Safety Principle
  basicSafetyPrincipleTitle: "Prinsip Keselamatan Dasar Grup",
  basicSafetyPrincipleDesc: "Keselamatan tidak hanya fundamental untuk manajemen yang menghargai martabat manusia, tetapi juga keinginan dan misi pribadi semua karyawan Grup.",
  
  // Basic Concept
  basicConceptTitle: "Konsep Dasar",
  basicConceptDesc: "Berdasarkan Prinsip Keselamatan Dasar Grup, Grup EKK mengembangkan sumber daya manusia yang sehat secara fisik dan mental. Pada saat yang sama, meningkatkan sistem manajemen K3 dan melibatkan pihak terkait untuk menciptakan lingkungan kerja yang nyaman, aman, dan memotivasi.",
  
  // Activity Policy
  activityPolicyTitle: "Kebijakan Kegiatan",
  activityPolicy1: "Identifikasi bahaya yang terkait dengan kegiatan bisnis secara tepat, asesmen risiko, dan kontrol bahaya dengan mempertimbangkan hierarki kontrol untuk mengurangi risiko dengan partisipasi dan kerjasama semua karyawan.",
  activityPolicy2: "Tetapkan target kesehatan dan keselamatan kerja dan kejar performa yang lebih baik melalui perbaikan berkelanjutan.",
  activityPolicy3: "Mematuhi hukum dan peraturan yang berlaku serta persyaratan lainnya.",
  activityPolicy4: "Menghargai diskusi aktif di tempat kerja, dengan menyadari bahwa komunikasi yang baik adalah bagian integral dari kesehatan dan keselamatan kerja.",
  activityPolicy5: "Menyediakan pendidikan dan pelatihan yang diperlukan untuk memastikan kesehatan dan keselamatan kerja sambil meningkatkan kesadaran karyawan akan pentingnya kesehatan dan keselamatan.",
  
  // OHS Performance
  ohsPerformanceTitle: "Performa K3",
  safetyCertification: "Sertifikasi Keselamatan",
  ltiRate: "Tingkat LTI",
  safetyTraining: "Pelatihan Keselamatan",
  healthCheckups: "Pemeriksaan Kesehatan",
  safetyInspections: "Inspeksi Keselamatan",
  emergencyDrills: "Latihan Darurat",
  
  // Performance Metrics
  performanceTitle: "Performa dan Target K3",
  performanceSubtitle: "Komitmen kami pada perbaikan keselamatan yang dapat diukur",
  performanceIndicator: "Indikator Performa",
  target: "Target",
  currentPerformance: "Performa Saat Ini",
  
  ltiRateLabel: "Tingkat Cedera Waktu Hilang (LTI)",
  totalRecordableInjuryRate: "Tingkat Cedera Tercatat Total",
  safetyTrainingCompletion: "Penyelesaian Pelatihan Keselamatan",
  hazardIdentification: "Identifikasi Bahaya",
  emergencyResponseTime: "Waktu Respons Darurat",
  
  performanceNote: "Catatan: Indikator performa dipantau secara bulanan dan ditinjau tahunan untuk perbaikan berkelanjutan.",
  
  // Safety Activities
  safetyActivitiesTitle: "Kegiatan Keselamatan",
  safetyActivitiesSubtitle: "Komitmen kami pada keselamatan melalui berbagai program dan inisiatif",
  safetyTrainingOverview: "Gambaran Pelatihan Keselamatan",
  
  // Training Activity
  trainingTitle: "Pelatihan",
  trainingDesc: "Pelatihan dengan topik Sistem Informasi B3 dan Identifikasi Aspek Lingkungan di Tempat Kerja secara rutin dilakukan setiap tahun untuk menjaga pemahaman dan meningkatkan kesadaran karyawan. Sesi pelatihan ini dirancang untuk memastikan semua karyawan dilengkapi dengan pengetahuan yang diperlukan untuk mengidentifikasi dan menangani material berbahaya dengan aman.",
  trainingHighlight1: "Pelatihan Sistem Informasi B3 (Material Berbahaya) tahunan",
  trainingHighlight2: "Sesi Identifikasi Aspek Lingkungan di Tempat Kerja",
  trainingHighlight3: "Pendidikan berkelanjutan untuk menjaga kesadaran keselamatan",
  trainingHighlight4: "Demonstrasi praktis dan latihan hands-on",
  b3TrainingSession: "Sesi Pelatihan B3",
  hazardIdentificationWorkshop: "Workshop Identifikasi Bahaya",
  
  // Safety Patrol Activity
  safetyPatrolTitle: "Patroli Keselamatan",
  safetyPatrolDesc: "Sebagai upaya menciptakan lingkungan kerja yang aman, perusahaan melakukan Patroli Keselamatan bulanan yang melibatkan tim HSE, Sachou (Direktur Presiden), dan Manajer dari semua departemen. Kegiatan ini berfokus pada identifikasi kondisi berbahaya dan memastikan implementasi metodologi 5S yang tepat di area kerja.",
  safetyPatrolHighlight1: "Patroli keselamatan bulanan dengan partisipasi lintas departemen",
  safetyPatrolHighlight2: "Fokus pada identifikasi kondisi berbahaya",
  safetyPatrolHighlight3: "Pemantauan dan evaluasi implementasi 5S",
  safetyPatrolHighlight4: "Pertemuan tindak lanjut reguler untuk meninjau perbaikan",
  monthlySafetyPatrol: "Patroli Keselamatan Bulanan",
  fiveSImplementationCheck: "Pemeriksaan Implementasi 5S",
  
  // Emergency Plan Activity
  emergencyPlanTitle: "Rencana Darurat",
  emergencyPlanDesc: "Dalam menghadapi situasi darurat, perusahaan telah menetapkan langkah penanganan yang terstruktur. Salah satu situasi darurat potensial yang diantisipasi adalah kebakaran. Perusahaan memiliki rencana pencegahan yang komprehensif, program pelatihan, kampanye kesadaran, dan inspeksi rutin untuk memastikan kesiapan menghadapi situasi darurat apa pun.",
  emergencyPlanHighlight1: "Pelatihan dan praktik APAR (Alat Pemadam Api Ringan)",
  emergencyPlanHighlight2: "Simulasi dan latihan evakuasi reguler",
  emergencyPlanHighlight3: "Pembentukan dan pelatihan tim respons darurat",
  emergencyPlanHighlight4: "Prosedur pemulihan dan evaluasi pasca-darurat",
  aparTrainingSession: "Sesi Pelatihan APAR",
  evacuationDrill: "Latihan Evakuasi",
  
  // Traffic Safety Initiatives
  trafficSafetyTitle: "Inisiatif Keselamatan Lalu Lintas",
  trafficSafetySubtitle: "Memastikan perjalanan dan transportasi yang aman untuk semua karyawan",
  
  // Safety Riding Program
  safetyRidingTitle: "Program Safety Riding",
  safetyRidingDesc: "Setiap tahun, kami mengorganisir pelatihan eksternal dengan tema Safety Riding, bekerja sama dengan profesional, sebagai upaya meningkatkan kesadaran dan keterampilan mengemudi yang aman bagi karyawan. Selain itu, dengan kegiatan pemeriksaan safety riding bulanan, kami berharap dapat membudayakan mengemudi yang aman dan bertanggung jawab.",
  safetyRidingHighlight1: "Pelatihan Safety Riding eksternal tahunan dengan profesional",
  safetyRidingHighlight2: "Pemeriksaan safety riding dan inspeksi kendaraan bulanan",
  safetyRidingHighlight3: "Membangun budaya mengemudi yang aman dan bertanggung jawab",
  safetyRidingHighlight4: "Meningkatkan kesadaran karyawan akan keselamatan lalu lintas",
  safetyRidingTraining: "Pelatihan Safety Riding",
  monthlyVehicleCheck: "Pemeriksaan Kendaraan Bulanan",
  
  // Health Promotion
  healthPromotionTitle: "Promosi Kesehatan",
  healthPromotionSubtitle: "Mendukung kesejahteraan karyawan melalui berbagai program kesehatan dan kesejahteraan",
  
  // Employee Wellness Programs
  employeeWellnessTitle: "Program Kesejahteraan Karyawan",
  employeeWellnessDesc: "Kami menyadari pentingnya kesehatan dan kebersihan karyawan kami. Jika karyawan sehat dan bebas dari penyakit, mereka akan bahagia di tempat kerja dan bekerja secara efisien. Perusahaan menyediakan berbagai pilihan kegiatan olahraga untuk mendukung kebugaran fisik dan kesejahteraan mental.",
  wellnessHighlight1: "Fasilitas gym yang lengkap untuk penggunaan karyawan",
  wellnessHighlight2: "Sesi olahraga aerobik reguler",
  wellnessHighlight3: "Klub bulu tangkis, tenis meja, dan voli",
  wellnessHighlight4: "Tim sepak bola dan klub lari untuk pecinta olahraga",
  
  // Activity Names
  gym: "Gym",
  aerobic: "Aerobik",
  badminton: "Bulu Tangkis",
  tableTennis: "Tenis Meja",
  volleyball: "Voli",
  soccer: "Sepak Bola",
  photos: "foto",
  
  // Related Topics
  relatedTopicsTitle: "Topik Keberlanjutan Terkait",
  relatedTopicsSubtitle: "Jelajahi lebih lanjut tentang inisiatif keberlanjutan kami",
  conceptOfSustainability: "Konsep Keberlanjutan",
  environmentalInitiatives: "Inisiatif Lingkungan",
  socialContributionInitiatives: "Inisiatif Kontribusi Sosial",
  
  // Buttons
  backToSustainability: "Kembali ke Keberlanjutan"
};